import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStoreApi } from '../../api';
import { storeKeys } from '../../query-key-factory';
import { EventDate } from '../../types/eventDate';
import { UpdateEventDateRequest } from './types';

const useUpdateEventDate = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const updateEventDate = async ({
    causeId,
    eventId,
    dateId,
    eventDate,
  }: UpdateEventDateRequest) => {
    const { data } = await StoreApi.put<EventDate>(
      `/store_items/${eventId}/event_dates/${dateId}?cause_id=${causeId}`,
      {
        cause_id: causeId,
        store_item_id: eventId,
        uuid: dateId,
        event_date: eventDate,
      }
    );
    return data;
  };

  return useMutation({
    mutationFn: updateEventDate,
    onSuccess(_, variables) {
      const { eventId, causeId } = variables;
      void queryClient.invalidateQueries({
        queryKey: storeKeys.id(causeId).items.events.id(eventId).dates.all,
      });
    },
  });
};

export { useUpdateEventDate };
